/* =========================================================
   DESKTOP TABS
========================================================= */

class ProductTabs {
  constructor(container) {
    this.container = container;

    this.buttons = [
      ...container.querySelectorAll('[data-tab-trigger]')
    ];

    this.panels = [
      ...container.querySelectorAll('[data-tab-panel]')
    ];

    this.init();
  }

  init() {
    this.bindEvents();
    this.handleDeepLink();
  }

  bindEvents() {
    this.buttons.forEach((button) => {

      button.addEventListener('click', () => {

        const target = button.dataset.tabTarget;

        this.openTab(target);

      });

    });
  }

  openTab(target) {

    this.buttons.forEach((button) => {
      button.classList.toggle(
        'is-active',
        button.dataset.tabTarget === target
      );
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle(
        'is-active',
        panel.dataset.tabId === target
      );
    });

    history.replaceState(
      null,
      '',
      `#${target}`
    );

  }

  handleDeepLink() {

    const hash = window.location.hash.replace('#', '');

    if (!hash) return;

    const matchingButton = this.buttons.find(
      (button) => button.dataset.tabTarget === hash
    );

    if (matchingButton) {
      this.openTab(hash);
    }

  }
}

/* =========================================================
   MOBILE ACCORDION
========================================================= */

class ProductAccordion {
  constructor(container) {
    this.container = container;

    this.items = [
      ...container.querySelectorAll('[data-accordion-item]')
    ];

    this.init();
  }

  init() {
    this.bindEvents();
    this.handleDeepLink();
  }

  bindEvents() {
  this.items.forEach((item) => {
    const trigger = item.querySelector('[data-accordion-trigger]');

    trigger.addEventListener('click', () => {
      item.classList.toggle('is-open');
    });
  });
}

  closeAll() {
    this.items.forEach((item) => {
      item.classList.remove('is-open');
    });
  }

  handleDeepLink() {

    const hash = window.location.hash.replace('#', '');

    if (!hash) return;

    const matchingItem = this.items.find(
      (item) => item.id === hash
    );

    if (matchingItem) {

      this.closeAll();

      matchingItem.classList.add('is-open');

    }

  }
}

/* =========================================================
   INIT
========================================================= */

document.addEventListener('DOMContentLoaded', () => {

  document
    .querySelectorAll('[data-product-tabs]')
    .forEach((tabs) => {
      new ProductTabs(tabs);
    });

  document
    .querySelectorAll('[data-product-accordion]')
    .forEach((accordion) => {
      new ProductAccordion(accordion);
    });

});